import React from 'react';

/**
 * issue #67 Phase F / issue #111 Task C: 自動保存 ON/OFF 切替 UI (controlled)。
 * enabled / onChange を親から受け取る。 localStorage 永続は親 (FingeringPage) が担う。
 *
 * FingeringPage 上部 (フォーム周辺) に配置される想定。
 */
export interface AutoSaveToggleProps {
  enabled: boolean;
  onChange: (next: boolean) => void;
}

export const AutoSaveToggle: React.FC<AutoSaveToggleProps> = ({ enabled, onChange }) => {
  return (
    <label className="flex items-center gap-2 cursor-pointer text-sm text-slate-700 select-none">
      <input
        type="checkbox"
        checked={enabled}
        onChange={() => onChange(!enabled)}
        className="w-4 h-4 accent-amber-500 cursor-pointer"
        aria-label="処理完了時に自動で Drive に保存"
      />
      <span>処理完了時に自動で Drive に保存</span>
    </label>
  );
};
